import { n as e } from "./PortalContainerContext-Cz7eWR3N.js";
import { Fragment as t, useCallback as n, useEffect as r, useLayoutEffect as i, useMemo as a, useReducer as o, useRef as s, useState as c } from "react";
import { BULK_UPDATE_DELAY as l, CUSTOM_LAST_MODIFIED_FORMAT as u, DEFAULT_PAGE_SIZE as d, FilterType as f, STATUS_BACKGROUND_COLOR as p, SseMessageType as m, SseTaskEventType as h, SseTaskMessageType as g, StatusEnum as _, TABLE_PAGE_SIZE_SELECTOR as v, TASK_ACTION_LABELS as y, TaskActions as b, config as x, fetchBulkAssignees as S, fetchTaskAssignees as C, fetchTaskComments as w, fetchTaskHistory as T, fetchViewTask as E, fetchViewTasks as D, getEventDescriptionHtml as O, getFilterOperator as k, getFilterOptions as A, getFilterValue as j, getLocalizedRelativeTime as M, getOverrideDateFormatter as N, getPossibleBulkActions as P, getProcessUrl as F, getTaskManagerResources as ee, initSseConnection as I, localizeString as L, removeComment as R, resetTaskManagerStores as z, saveComment as B, setAccessToken as V, sortedColumnState as te, taskManagerAnalytics as H, toViewTasksSorts as ne, transformUsersToOptions as U, updateBulkTaskAction as re, updateTaskAction as W, updateTaskPriority as ie } from "@flowx/core-sdk";
import { clsx as G } from "clsx";
import { ThemeComponent as K } from "@flowx/core-theme";
import { getThemingClassName as q, useCustomStyles as J } from "@flowx/react-theme";
import { FlxButton as Y, FlxCard as ae, FlxCheckbox as oe, FlxChoiceGroupContainer as se, FlxIcon as ce, FlxInput as le, FlxInputContainer as ue, FlxInputField as X, FlxModal as de, FlxSelect as fe, FlxSelectContainer as pe, FlxSelectOption as me, FlxSpinner as he, MemoFlxButton as ge, MemoFlxCheckboxGroup as _e, MemoFlxIcon as Z, MemoFlxInput as ve, MemoFlxInputContainer as ye, MemoFlxRadio as be, MemoFlxRadioGroup as xe, MemoFlxSelectOption as Se, MemoFlxTable as Ce } from "@flowx/react-ui-toolkit";
import { Fragment as we, jsx as Q, jsxs as $ } from "react/jsx-runtime";
import { debounce as Te, isEqual as Ee, isObject as De, parseInt as Oe } from "lodash";
import { useGridFilter as ke } from "ag-grid-react";
import { AG_GRID_LOCALE_BG as Ae, AG_GRID_LOCALE_CN as je, AG_GRID_LOCALE_CZ as Me, AG_GRID_LOCALE_DE as Ne, AG_GRID_LOCALE_DK as Pe, AG_GRID_LOCALE_EG as Fe, AG_GRID_LOCALE_ES as Ie, AG_GRID_LOCALE_FI as Le, AG_GRID_LOCALE_FR as Re, AG_GRID_LOCALE_GR as ze, AG_GRID_LOCALE_HR as Be, AG_GRID_LOCALE_HU as Ve, AG_GRID_LOCALE_IL as He, AG_GRID_LOCALE_IR as Ue, AG_GRID_LOCALE_IT as We, AG_GRID_LOCALE_JP as Ge, AG_GRID_LOCALE_KR as Ke, AG_GRID_LOCALE_NL as qe, AG_GRID_LOCALE_NO as Je, AG_GRID_LOCALE_PK as Ye, AG_GRID_LOCALE_PL as Xe, AG_GRID_LOCALE_PT as Ze, AG_GRID_LOCALE_SE as Qe, AG_GRID_LOCALE_SK as $e, AG_GRID_LOCALE_TR as et, AG_GRID_LOCALE_UA as tt, AG_GRID_LOCALE_VN as nt } from "@ag-grid-community/locale";
import './FlxTaskManager.css';//#region libs/sdk/react/src/components/sdk/task-manager/filters/BooleanFilterComponent.tsx
var rt = ({ model: e, onModelChange: t, colDef: i, context: a, getValue: o, api: l }) => {
	let u = s(null), [d, f] = c(e?.filter), p = l.getGridOption("localeText"), m = q(K.Radio), h = n(({ data: e }) => {
		let t = o(e, i.field);
		return a.isServerSide ? !0 : d === void 0 || t === d;
	}, [
		i.field,
		a.isServerSide,
		d
	]), g = n((e) => {
		(!e || !e.suppressFocus) && u.current?.focus();
	}, []);
	ke({
		doesFilterPass: h,
		afterGuiAttached: g
	});
	let _ = (e) => {
		f(e === void 0 ? e : e === "true");
	};
	return r(() => {
		d === void 0 ? e && t(null) : t({
			...e,
			filter: d,
			filterType: "boolean",
			type: "equals"
		});
	}, [d]), /* @__PURE__ */ $("div", {
		className: "ag-filter-wrapper ag-focus-managed filter-containers",
		children: [/* @__PURE__ */ Q("div", {
			className: "ag-filter-body-wrapper ag-simple-filter-body-wrapper",
			children: /* @__PURE__ */ Q(se, {
				ref: u,
				direction: "column",
				className: G(m, "radio-group"),
				children: /* @__PURE__ */ $(xe, {
					tabIndex: -1,
					name: "option",
					value: d?.toString() || "",
					defaultValue: d?.toString() || "",
					onValueChange: (e) => _(e),
					children: [/* @__PURE__ */ Q(be, {
						label: p?.true || "True",
						value: "true"
					}), /* @__PURE__ */ Q(be, {
						label: p?.false || "False",
						value: "false"
					})]
				})
			})
		}), /* @__PURE__ */ Q("div", {
			className: "ag-filter-apply-panel",
			children: /* @__PURE__ */ Q("button", {
				className: "ag-button ag-standard-button ag-filter-apply-panel-button",
				onClick: () => {
					d !== void 0 && f(void 0);
				},
				children: p?.resetFilter || "Reset"
			})
		})]
	});
}, it = () => /* @__PURE__ */ Q(Z, { name: "search" }), at = ({ model: e, onModelChange: t, options: i = [], context: a, getValue: o, colDef: l, api: u }) => {
	let d = s(null), [f, p] = c(e?.filter || []), [m, h] = c(""), g = u.getGridOption("localeText"), _ = q(K.Input), v = q(K.Checkbox), y = i.filter(({ label: e }) => e.toLowerCase().includes(m.toLowerCase())), b = n(({ node: e }) => {
		let t = o(e, l.field);
		return a.isServerSide ? !0 : f.includes(t);
	}, [
		l.field,
		a.isServerSide,
		f
	]), x = n((e) => {
		(!e || !e.suppressFocus) && d.current?.focus();
	}, []);
	ke({
		doesFilterPass: b,
		afterGuiAttached: x
	});
	let S = (e, t) => {
		p((n) => t ? [...n, e] : n.filter((t) => t !== e));
	};
	return r(() => {
		f.length > 0 ? t({
			...e,
			filter: f,
			filterType: "enum",
			type: "in"
		}) : e && t(null);
	}, [f]), /* @__PURE__ */ $("div", {
		className: "ag-filter-wrapper ag-focus-managed filter-containers",
		children: [/* @__PURE__ */ $("div", {
			className: "ag-filter-body-wrapper ag-simple-filter-body-wrapper",
			children: [/* @__PURE__ */ Q(ue, {
				className: G(_, "search-container"),
				children: /* @__PURE__ */ Q(ve, {
					prefixIcon: it,
					children: /* @__PURE__ */ Q(X, {
						value: m,
						onChange: (e) => h(e.target.value),
						placeholder: g?.searchOoo || "Search..."
					})
				})
			}), /* @__PURE__ */ Q(se, {
				ref: d,
				className: G(v, "checkbox-group"),
				direction: "column",
				children: /* @__PURE__ */ Q(_e, {
					tabIndex: -1,
					noBorder: !0,
					children: y.map(({ id: e, label: t, value: n }) => /* @__PURE__ */ Q(oe, {
						label: t,
						value: n,
						checked: f.includes(n),
						onCheckedChange: (e) => S(n, !!e)
					}, e))
				})
			})]
		}), /* @__PURE__ */ Q("div", {
			className: "ag-filter-apply-panel",
			children: /* @__PURE__ */ Q("button", {
				className: "ag-button ag-standard-button ag-filter-apply-panel-button",
				onClick: () => {
					f.length !== 0 && p([]);
				},
				children: g?.resetFilter || "Reset"
			})
		})]
	});
}, ot = {
	[f.booleanType]: rt,
	[f.enumType]: at
}, st = (e, t) => [...e.sort((e, t) => e.order - t.order).map((e) => {
	let n = {
		headerName: L(e.displayName),
		field: e.keyName,
		sortable: !0,
		suppressMovable: !0,
		flex: 1,
		comparator: () => 0,
		...A(e, t, ot),
		filterValueGetter: ({ context: t, api: n, colDef: r, data: i }) => t.isServerSide ? ct(n.getFilterModel()[r?.field || ""]) : i?.[e.keyName],
		valueGetter: (t) => t.data ? t.data[e.keyName] : void 0,
		cellRenderer: (e) => e.value == null ? "" : e.value
	};
	return e.sort?.active && (n.sort = e.sort.direction === "ASC" ? "asc" : "desc", n.sortingOrder = ["asc", "desc"]), n;
})], ct = (e) => {
	switch (e?.filterType) {
		case "text": return lt(e);
		case "number": return ut(e);
		case "date": return dt(e);
		case "boolean": return !0;
		case "enum": return e.filter;
		default: return "";
	}
}, lt = (e) => {
	switch (e.type) {
		case "notEqual": return "";
		case "notContains": return "";
		default: return e.filter;
	}
}, ut = (e) => {
	switch (e.type) {
		case "lessThan": return e.filter - 1;
		case "greaterThan": return e.filter + 1;
		default: return e.filter;
	}
}, dt = (e) => {
	let t;
	switch (e.type) {
		case "lessThan": return t = new Date(e.dateFrom), t.setDate(t.getDate() - 1), t;
		case "greaterThan": return t = new Date(e.dateFrom), t.setDate(t.getDate() + 1), t;
		default: return e.dateFrom;
	}
}, ft = (e, t) => Object.keys(e).map((n) => {
	let r = t.find((e) => e.keyName === n);
	return r ? {
		keyName: n,
		keyType: r.keyType,
		columnType: r.columnType,
		operator: k(e[n].type),
		value: j(e[n], r)
	} : null;
}).filter(Boolean), pt = (e) => e.map((e) => ({
	...e.columnValues,
	agGridId: e.tokenUuid
})), mt = (e) => new Promise((t) => setTimeout(t, e)), ht = {
	filters: [],
	sort: [],
	keyword: "",
	viewData: void 0,
	pageNumber: 0,
	totalNumberOfRows: 0,
	rebuildRequired: !1,
	pagedTasks: {},
	tasksDetails: {},
	selectedTask: void 0,
	enumerations: {},
	isTasksLoading: !1,
	selectedTasks: []
};
function gt(e, t) {
	switch (t.type) {
		case "SET_FILTERS": return {
			...e,
			filters: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_SORT": return {
			...e,
			sort: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_KEYWORD": return {
			...e,
			keyword: t.payload,
			rebuildRequired: !0,
			pagedTasks: {}
		};
		case "SET_PAGE_NUMBER": return {
			...e,
			pageNumber: t.payload
		};
		case "SET_TOTAL_NUMBER_OF_ROWS": return e.totalNumberOfRows === t.payload ? e : {
			...e,
			totalNumberOfRows: t.payload
		};
		case "SET_REBUILD_REQUIRED": return {
			...e,
			rebuildRequired: t.payload,
			pagedTasks: t.payload ? {} : e.pagedTasks
		};
		case "SET_PAGED_TASKS": {
			let n = e.pagedTasks[t.payload.pageNumber];
			return n && Ee(n, t.payload.tasks) ? e : {
				...e,
				pagedTasks: {
					...e.pagedTasks,
					[t.payload.pageNumber]: t.payload.tasks
				}
			};
		}
		case "SET_TASKS_LOADING": return {
			...e,
			isTasksLoading: t.payload
		};
		case "SET_SELECTED_TASKS": return {
			...e,
			selectedTasks: t.payload
		};
		case "SET_TASKS_DETAILS": return {
			...e,
			tasksDetails: {
				...e.tasksDetails,
				...t.payload
			}
		};
		case "SET_SELECTED_TASK": return {
			...e,
			selectedTask: t.payload
		};
		default: return e;
	}
}
var _t = (e) => e.selectedTask ? e.tasksDetails[e.selectedTask.id] : {
	comments: [],
	history: []
}, vt = async (e) => {
	let t = e.currentSwimlane.owner?.username, n = !1;
	if (t) {
		let r = await C(e.id, e.tokenUuid, { keyword: t });
		r.length && e.currentSwimlane?.owner && (n = r[0].enabled);
	}
	return n;
};
function yt(e, t, i, c) {
	let [u, d] = o(gt, {
		...ht,
		viewData: e,
		enumerations: t
	}), f = s(null), p = s(u.selectedTask), _ = s(!1), v = n((e) => {
		d({
			type: "SET_FILTERS",
			payload: e
		});
	}, []), y = n((e) => {
		d({
			type: "SET_SORT",
			payload: e
		});
	}, []), x = n(Te((e) => {
		d({
			type: "SET_KEYWORD",
			payload: e
		}), c?.searched(e), u.pageNumber !== 0 && d({
			type: "SET_PAGE_NUMBER",
			payload: 0
		});
	}, 600), [u.pageNumber]), O = n((e) => {
		d({
			type: "SET_PAGE_NUMBER",
			payload: e
		});
	}, []), k = n((e) => {
		d({
			type: "SET_SELECTED_TASKS",
			payload: e
		});
	}, []), A = n(async () => {
		if (u.pagedTasks[u.pageNumber] === void 0 || u.rebuildRequired) {
			let t = _.current;
			_.current = !1, t || d({
				type: "SET_TASKS_LOADING",
				payload: !0
			});
			let n = await D(u.sort, u.filters, u.keyword, e, {
				page: u.pageNumber,
				size: i
			}, u.enumerations), r = u.pageNumber, { content: a, totalElements: o } = n;
			d({
				type: "SET_PAGED_TASKS",
				payload: {
					pageNumber: r,
					tasks: a
				}
			}), d({
				type: "SET_TOTAL_NUMBER_OF_ROWS",
				payload: o
			}), d({
				type: "SET_REBUILD_REQUIRED",
				payload: !1
			}), c?.loaded(o), t || d({
				type: "SET_TASKS_LOADING",
				payload: !1
			});
		}
	}, [
		u.pagedTasks,
		u.pageNumber,
		u.rebuildRequired,
		u.sort,
		u.filters,
		u.keyword,
		u.enumerations,
		e,
		i,
		c
	]), j = n(async (e, t = !1) => {
		if (u.tasksDetails[e] === void 0 || t) {
			let t = await w(e), n = await T(e);
			d({
				type: "SET_TASKS_DETAILS",
				payload: { [e]: {
					comments: t,
					history: n
				} }
			});
		}
	}, [u.tasksDetails]), M = n(async (e) => {
		let { pageNumber: t, pagedTasks: n } = u;
		if (t === void 0 || e === -1) {
			d({
				type: "SET_SELECTED_TASK",
				payload: void 0
			});
			return;
		}
		let r = n[t]?.[e - t * i];
		r?.currentSwimlane?.owner?.username && (r.currentSwimlane.owner.enabled = await vt(r)), d({
			type: "SET_SELECTED_TASK",
			payload: r
		}), j(r.id);
	}, [u, i]), N = n(async (e, t) => {
		let { selectedTasks: n } = u;
		if (n.length === 0) return;
		let r = n.map(({ id: e, tokenUuid: t }) => ({
			id: e,
			tokenUuid: t
		}));
		k([]), z(), await re(r, e, t), c?.taskActioned(e, n.map((e) => e.processInstance?.processState), r.length), await mt(l), d({
			type: "SET_REBUILD_REQUIRED",
			payload: !0
		}), V();
	}, [u.selectedTasks, c]), P = n(async (e) => S(u.selectedTasks, { keyword: e }), [u.selectedTasks]), F = n(async (e, t) => {
		try {
			let n = await B(e, { message: t }), r = _t(u);
			return d({
				type: "SET_TASKS_DETAILS",
				payload: {
					...u.tasksDetails,
					[e]: {
						...r,
						comments: [n, ...r.comments]
					}
				}
			}), n;
		} catch (e) {
			console.error("Error saving comment:", e);
			return;
		}
	}, [u]), ee = n(async (e, t) => {
		try {
			await R(e, t);
			let n = _t(u);
			d({
				type: "SET_TASKS_DETAILS",
				payload: {
					...u.tasksDetails,
					[e]: {
						...n,
						comments: n.comments.filter((e) => e.commentId !== t)
					}
				}
			});
		} catch (e) {
			console.error("Error deleting comment:", e);
		}
	}, [u]), L = n(async (e, t) => {
		switch (e.type) {
			case m.Open:
				console.log("SSE connection open");
				break;
			case m.Error:
				console.error("SSE connection error", e);
				break;
			case m.Data: if (t?.eventType === g.VIEW_UPDATED) switch (t?.taskEventType) {
				case h.TASK_UPDATED:
				case h.TASK_CREATED:
					if (p.current && p.current.id === t.taskId) {
						let e = await E(p.current.id, p.current.tokenUuid);
						e.currentSwimlane?.owner?.username && (e.currentSwimlane.owner.enabled = await vt(e)), d({
							type: "SET_SELECTED_TASK",
							payload: {
								...p.current,
								...e
							}
						}), j(e.id, !0);
					}
					_.current = !0, d({
						type: "SET_REBUILD_REQUIRED",
						payload: !0
					});
			}
		}
	}, []), z = n(() => {
		try {
			f.current?.close();
		} catch (e) {
			if (e?.name !== "AbortError") throw e;
		}
	}, []), V = n(() => {
		let e = u.viewData?.resourceId;
		e && (z(), f.current = I(e, L));
	}, [
		u.viewData?.resourceId,
		L,
		z
	]);
	r(() => (V(), () => {
		z();
	}), [V, z]), r(() => {
		let e = () => {
			document.visibilityState === "hidden" ? z() : document.visibilityState === "visible" && (V(), _.current = !0, d({
				type: "SET_REBUILD_REQUIRED",
				payload: !0
			}));
		};
		return document.addEventListener("visibilitychange", e), () => document.removeEventListener("visibilitychange", e);
	}, [V, z]), r(() => {
		u.pageNumber !== void 0 && A();
	}, [A, u.pageNumber]), r(() => {
		d({
			type: "SET_REBUILD_REQUIRED",
			payload: !0
		}), u.pageNumber !== 0 && d({
			type: "SET_PAGE_NUMBER",
			payload: 0
		});
	}, [i]), r(() => {
		p.current?.id !== u.selectedTask?.id && (p.current = u.selectedTask);
	}, [u.selectedTask]);
	let te = n(async (e, t) => e === void 0 ? [] : C(e.id, e.tokenUuid, { keyword: t }), []), H = n(async (e, t) => {
		t !== void 0 && (await ie(t.id, e), c?.priorityChanged(e));
	}, [c]), ne = n((e) => {
		let t = e.selectedTask;
		if (t) return {
			task: t,
			details: _t(e),
			onActionUpdate: async (e, n) => {
				await W(e, t.id, t.tokenUuid, n), c?.taskActioned(e, t.processInstance?.processState);
			},
			onViewApplication: () => c?.taskActioned(b.VIEW, t.processInstance?.processState),
			onCommentCreate: (e) => F(t.id, e),
			onCommentDelete: (e) => ee(t.id, e),
			onPriorityUpdate: (e) => H(e, t),
			searchAssignees: (e) => te(t, e)
		};
	}, [
		F,
		ee,
		H,
		te,
		c
	]), U = a(() => ne(u), [ne, u]);
	return {
		...u,
		setFilters: v,
		setSort: y,
		onKeywordChange: x,
		onPageNumberChange: O,
		onSelectedTaskChanged: M,
		selectedTaskWithDetails: U,
		setSelectedTasks: k,
		onBulkTaskActionUpdate: N,
		searchBulkAssignees: P
	};
}
//#endregion
//#region libs/sdk/react/src/components/sdk/task-manager/task-detail/task-priority/FlxTaskPriority.tsx
var bt = ({ priority: e = null, onPriorityUpdate: t, canEditPriority: n }) => {
	let [i, a] = c(!1), [o, s] = c(e), l = q(K.Button), u = q(K.Input), d = J({
		styles: {},
		component: K.Button
	}), f = J({
		styles: {},
		component: K.Button
	}), p = J({
		styles: {},
		component: K.Button
	}), m = () => a(!0), h = () => {
		a(!1), o !== e && t?.(o);
	}, g = () => {
		a(!1), s(e);
	}, _ = (e) => {
		let t = e.target.value, n = Oe(t, 10);
		s(isNaN(n) ? null : n);
	}, v = (e) => {
		"key" in e && (e.key === "-" || e.key === "Minus") && e.preventDefault(), "clipboardData" in e && e.clipboardData.getData("text").trim().startsWith("-") && e.preventDefault();
	};
	return r(() => {
		let t = e?.toString().replace(/^-+/, "");
		t !== o?.toString() && i && s(t ? Oe(t, 10) : null);
	}, [i]), /* @__PURE__ */ $("div", {
		className: "priority-container",
		children: [/* @__PURE__ */ Q("div", {
			className: "info-title",
			children: L("@@sys_tm_priority")
		}), /* @__PURE__ */ Q("div", {
			className: "info-row",
			children: i ? /* @__PURE__ */ $(we, { children: [
				/* @__PURE__ */ Q(ue, {
					className: G(u, "priority-input"),
					children: /* @__PURE__ */ Q(ve, { children: /* @__PURE__ */ Q(X, {
						value: o ?? "",
						onChange: _,
						type: "number",
						onKeyDown: v,
						onPaste: v
					}) })
				}),
				/* @__PURE__ */ Q(ge, {
					variant: "fill",
					onClick: h,
					className: G(l, ...d, "priority-button", "check-button"),
					"data-uniqueid": "check-button",
					children: /* @__PURE__ */ Q(Z, {
						name: "check",
						className: "check-icon"
					})
				}),
				/* @__PURE__ */ Q(ge, {
					onClick: g,
					className: G(l, ...f, "dismiss-button priority-button"),
					variant: "fill",
					"data-uniqueid": "dismiss-button",
					children: /* @__PURE__ */ Q(Z, {
						name: "close",
						className: "dismiss-icon"
					})
				})
			] }) : /* @__PURE__ */ $(we, { children: [/* @__PURE__ */ Q("div", {
				className: "priority-value",
				children: o ?? "-"
			}), n ? /* @__PURE__ */ Q(ge, {
				variant: "ghost",
				"data-uniqueid": "edit-button",
				disabled: !n,
				onClick: m,
				className: G(l, ...p, "edit-button"),
				children: /* @__PURE__ */ Q(Z, {
					name: "edit",
					className: "edit-icon"
				})
			}) : null] })
		})]
	});
}, xt = ({ history: e = [] }) => /* @__PURE__ */ $("div", {
	className: "flx-history-section",
	children: [/* @__PURE__ */ Q("h6", {
		className: "title",
		children: L("@@sys_tm_history")
	}), /* @__PURE__ */ Q("ul", {
		className: "history-list",
		children: e?.map(({ date: e, historyId: n, events: r }) => /* @__PURE__ */ Q(t, { children: r.map((t, n) => /* @__PURE__ */ $("li", {
			className: "history-entry",
			children: [/* @__PURE__ */ Q("div", {
				className: "history-log-date",
				children: M(e, x().language)
			}), /* @__PURE__ */ Q("div", {
				className: "history-log-message",
				dangerouslySetInnerHTML: { __html: O(t) }
			}, n)]
		}, n)) }, n))
	})]
}), St = ({ comments: e = [], onCommentCreate: t, onCommentDelete: r }) => {
	let [i, o] = c(""), l = s(""), u = q(K.Input), d = q(K.Button), f = (e) => {
		l.current = e.target.value, o(e.target.value);
	}, p = n(async () => {
		l.current && await t(l.current) && (l.current = "", o(""));
	}, [t]), m = async (e) => {
		r(e);
	}, h = !i, g = a(() => function() {
		return /* @__PURE__ */ Q(ce, {
			name: "send",
			onClick: h ? void 0 : p,
			className: G("comment-send", { disabled: h })
		});
	}, [h, p]);
	return /* @__PURE__ */ $("div", {
		className: "flx-comments-section",
		children: [
			/* @__PURE__ */ Q("h6", {
				className: "title",
				children: L("@@sys_tm_comments")
			}),
			/* @__PURE__ */ Q(ue, {
				className: G(u, "comment-input"),
				children: /* @__PURE__ */ Q(le, {
					filled: !!i,
					suffixIcon: g,
					children: /* @__PURE__ */ Q(X, {
						value: i,
						onChange: f,
						onKeyDown: (e) => e.key === "Enter" && p(),
						placeholder: L("@@sys_tm_write_a_comment")
					})
				})
			}),
			/* @__PURE__ */ Q("ul", {
				className: "comments-list",
				children: e?.map(({ commentId: e, author: t, message: n, createdDate: r }) => /* @__PURE__ */ $("li", { children: [/* @__PURE__ */ $("div", {
					className: "comment-info",
					children: [/* @__PURE__ */ $("div", {
						className: "comment-author",
						children: [/* @__PURE__ */ $("div", {
							className: "avatar",
							children: [t.firstName.charAt(0).toUpperCase(), t.lastName.charAt(0).toUpperCase()]
						}), /* @__PURE__ */ $("span", { children: [
							t.firstName,
							" ",
							t.lastName
						] })]
					}), /* @__PURE__ */ $("div", {
						className: "comment-actions",
						children: [/* @__PURE__ */ Q(Y, {
							variant: "text",
							className: G(d),
							onClick: () => m(e),
							children: /* @__PURE__ */ Q(ce, { name: "trash" })
						}), /* @__PURE__ */ Q("span", {
							className: "comment-date",
							children: M(r, x().language)
						})]
					})]
				}), /* @__PURE__ */ Q("div", {
					className: "comment-message",
					children: n
				})] }, e))
			})
		]
	});
}, Ct = ({ task: t, details: i, searchAssignees: o, onCommentCreate: l, onCommentDelete: d, onActionUpdate: f, onPriorityUpdate: m, onViewApplication: h }) => {
	let { currentSwimlane: g, processInstance: v, modifiedDate: x, stage: S, priority: C, title: w, baseUrl: T, possibleActions: E = [], appId: D } = t || {}, O = e(), [k, A] = c(g?.owner?.username || ""), [j, M] = c(g?.owner ? U([g?.owner]).map((e) => ({
		...e,
		enabled: !0
	})) : []), [P, ee] = c(""), [I, R] = c(!1), z = s(!1), B = s(k);
	B.current = k;
	let V = s(j);
	V.current = j;
	let te = x ? N(u)?.format(new Date(x)) : "-", H = q(K.Button), ne = q(K.Select), re = q(K.SelectOption), W = p[v.processState], ie = a(() => I ? L("@@sys_tm_loading") : P.length < 4 ? L("@@sys_tm_search_term_validation") : L("@@sys_tm_nothing_found"), [I, P]), J = n(() => {
		let e = v?.contextInstanceUuid || v?.processInstanceUuid;
		T && e && D && (h?.(), window.open(F(T, D, e), "_blank"));
	}, [
		T,
		D,
		v?.contextInstanceUuid,
		v?.processInstanceUuid,
		h
	]), ae = Te(async (e) => {
		R(!0);
		try {
			if (z.current) z.current = !1;
			else {
				let t = await o(e);
				M(U(t).map((e) => ({
					...e,
					enabled: !0
				})));
			}
		} catch (e) {
			M([]), z.current = !1, console.error("Error while searching users", e);
		} finally {
			R(!1);
		}
	}, 600), oe = n(async (e) => {
		if (ee(e), !(B.current && e === V.current.find((e) => e.value === B.current)?.label)) {
			if (!e.trim() || e.length < 4) {
				ae.cancel(), B.current || M([]);
				return;
			}
			await ae(e);
		}
	}, []), se = (e) => {
		let t = e;
		z.current = !0, f(b.ASSIGN, t.value), A(t.value);
	};
	r(() => {
		A(g?.owner?.username || ""), M(g?.owner?.username ? U([g?.owner]).map((e) => ({
			...e,
			enabled: !0
		})) : []);
	}, [g]);
	let ce = b.HOLD, le = b.UNHOLD, ue = b.ASSIGN, X = b.UNASSIGN, de = b.SELF_ASSIGN, me = a(() => _.reduce((e, t) => ({
		...e,
		[t.id]: L(t.label)
	}), {}), []);
	return /* @__PURE__ */ $("div", {
		className: "flx-task-container",
		children: [
			/* @__PURE__ */ $("div", {
				className: "flx-task-header",
				children: [/* @__PURE__ */ Q("h5", { children: w || L("@@sys_tm_title") }), /* @__PURE__ */ $("div", {
					className: "flx-status-container",
					children: [/* @__PURE__ */ Q("span", {
						className: "flx-status-badge",
						style: { backgroundColor: W },
						children: me[v?.processState]
					}), [ce, le].map((e) => E.includes(e) ? /* @__PURE__ */ Q(Y, {
						variant: "text",
						onClick: () => f(e),
						className: G(H, "flx-button-assign"),
						children: L(y[e])
					}, e) : null)]
				})]
			}),
			/* @__PURE__ */ $("div", {
				className: "task-details",
				children: [
					/* @__PURE__ */ Q(bt, {
						canEditPriority: E.includes(b.CHANGE_PRIORITY),
						priority: C,
						onPriorityUpdate: m
					}),
					/* @__PURE__ */ $("div", {
						className: "detail-item",
						children: [/* @__PURE__ */ Q("strong", { children: L("@@sys_tm_stage") }), /* @__PURE__ */ $("span", { children: [S, "\xA0"] })]
					}),
					/* @__PURE__ */ $("div", {
						className: "detail-item",
						children: [/* @__PURE__ */ Q("strong", { children: L("@@sys_tm_last_updated") }), /* @__PURE__ */ Q("span", { children: te })]
					}),
					/* @__PURE__ */ Q(Y, {
						variant: "fill",
						disabled: !T,
						onClick: J,
						className: G(H),
						children: L(y[b.VIEW])
					})
				]
			}),
			/* @__PURE__ */ $("div", {
				className: "flx-assignee-section",
				children: [/* @__PURE__ */ Q(pe, {
					className: G(ne, "flx-select-assignee"),
					children: /* @__PURE__ */ Q(fe, {
						hasSearch: !0,
						hasClear: !0,
						useServerFiltering: !0,
						options: j,
						onSearch: oe,
						disabled: !E.includes(ue),
						onChange: se,
						clearFn: () => {
							A(""), M([]);
						},
						value: j.find((e) => e.value === k) || null,
						emptyMessage: ie,
						placeholder: L("@@sys_tm_select_person"),
						optionClassName: G(re),
						container: O,
						children: (e, t) => /* @__PURE__ */ Q(Se, {
							label: e.label,
							className: G(re),
							onClick: t
						}, e.value)
					})
				}), [X, de].map((e) => /* @__PURE__ */ Q(Y, {
					variant: "ghost",
					onClick: () => {
						f(e);
					},
					className: G(H, "flx-button-assign"),
					disabled: !E.includes(e),
					children: L(y[e])
				}, e))]
			}),
			/* @__PURE__ */ $("div", {
				className: "task-grid",
				children: [/* @__PURE__ */ Q(St, {
					comments: i?.comments,
					onCommentCreate: l,
					onCommentDelete: d
				}), /* @__PURE__ */ Q(xt, { history: i?.history })]
			})
		]
	});
}, wt = () => /* @__PURE__ */ Q(Z, { name: "search" }), Tt = ({ tasks: e, onUpdateTasks: t, searchUsers: i }) => {
	let [o, l] = c(""), [u, d] = c([]), [f, p] = c(!1), [m, h] = c(!1), [g, _] = c(!1), v = s({
		top: 0,
		left: 0
	}), y = a(() => L(m ? "@@sys_tm_loading" : g ? "@@sys_tm_nothing_found" : "@@sys_tm_search_term_validation"), [m, g]), x = q(K.Button), S = q(K.Card), C = q(K.Input), w = q(K.SelectOption), T = a(() => P(e), [e]), E = n(Te(async (e) => {
		h(!0);
		try {
			let t = await i(e);
			d(U(t)), _(!0);
		} catch (e) {
			d([]), console.error("Error while searching users", e);
		} finally {
			h(!1);
		}
	}, 600), [i]), D = (e) => {
		let t = e.currentTarget, n = t.getBoundingClientRect(), r = t.closest(".flx-task-management-container")?.getBoundingClientRect() ?? {
			top: 0,
			left: 0
		};
		v.current = {
			top: n.bottom - r.top,
			left: n.left - r.left
		}, p(!0);
	}, O = () => {
		p(!1), l(""), d([]);
	}, k = (e) => {
		t(b.ASSIGN, e), O();
	}, A = (e, n) => {
		if (n === b.ASSIGN) {
			D(e);
			return;
		}
		t(n);
	};
	return r(() => {
		if (o.length < 4) {
			_(!1), d([]);
			return;
		}
		E(o);
	}, [o, i]), /* @__PURE__ */ Q("div", {
		className: "flx-bulk-tasks",
		children: /* @__PURE__ */ $("div", {
			className: G("flx-task-actions", { empty: T.length === 0 }),
			children: [T.map(({ value: e, label: t }) => /* @__PURE__ */ Q(Y, {
				variant: "ghost",
				className: G(x),
				onClick: (t) => A(t, e),
				children: t
			}, e)), f && /* @__PURE__ */ $(we, { children: [/* @__PURE__ */ Q("div", {
				className: "flx-assign-users-search-backdrop",
				onClick: () => O()
			}), /* @__PURE__ */ $(ae, {
				className: G(S, "flx-assign-users-search"),
				style: {
					top: `${v.current.top}px`,
					left: `${v.current.left}px`
				},
				children: [
					/* @__PURE__ */ Q(ye, {
						className: G(C),
						children: /* @__PURE__ */ Q(ve, {
							prefixIcon: wt,
							children: /* @__PURE__ */ Q(X, {
								value: o,
								onChange: (e) => l(e.target.value),
								placeholder: L("@@sys_tm_search_person")
							})
						})
					}),
					u.length === 0 && /* @__PURE__ */ Q(me, {
						className: G(w, "flx-select-option-empty"),
						label: y
					}),
					u.map(({ value: e, label: t }) => /* @__PURE__ */ Q(me, {
						className: G(w),
						label: t,
						onClick: () => k(e)
					}, e))
				]
			})] })]
		})
	});
}, Et = {
	ar: Fe,
	bg: Ae,
	cs: Me,
	da: Pe,
	de: Ne,
	el: ze,
	es: Ie,
	fa: Ue,
	fi: Le,
	fr: Re,
	he: He,
	hr: Be,
	hu: Ve,
	it: We,
	ja: Ge,
	ko: Ke,
	nb: Je,
	nl: qe,
	pl: Xe,
	pt: Ze,
	ro: {
		selectAll: "(Selectează tot)",
		selectAllSearchResults: "(Selectează toate rezultatele căutării)",
		addCurrentSelectionToFilter: "Adaugă selecția curentă la filtru",
		searchOoo: "Căutare...",
		blanks: "(Goluri)",
		noMatches: "Fără potriviri",
		typeToSearchOoo: "Tastează pentru a căuta...",
		filterOoo: "Filtrează...",
		equals: "Egal",
		notEqual: "Nu este egal",
		blank: "Gol",
		notBlank: "Nu este gol",
		empty: "Alege una",
		lessThan: "Mai puțin decât",
		greaterThan: "Mai mult decât",
		lessThanOrEqual: "Mai puțin sau egal cu",
		greaterThanOrEqual: "Mai mult sau egal cu",
		inRange: "Între",
		inRangeStart: "De la",
		inRangeEnd: "Până la",
		contains: "Conține",
		notContains: "Nu conține",
		startsWith: "Începe cu",
		endsWith: "Se termină cu",
		dateFormatOoo: "yyyy-mm-dd",
		before: "Înainte",
		after: "După",
		yesterday: "Ieri",
		today: "Astăzi",
		tomorrow: "Mâine",
		last7Days: "Ultimele 7 zile",
		lastWeek: "Săptămâna trecută",
		thisWeek: "Această săptămână",
		nextWeek: "Săptămâna viitoare",
		last30Days: "Ultimele 30 de zile",
		lastMonth: "Luna trecută",
		thisMonth: "Această lună",
		nextMonth: "Luna viitoare",
		last90Days: "Ultimele 90 de zile",
		lastQuarter: "Trimestrul trecut",
		thisQuarter: "Acest trimestru",
		nextQuarter: "Trimestrul viitor",
		lastYear: "Anul trecut",
		thisYear: "Acest an",
		yearToDate: "De la începutul anului până în prezent",
		nextYear: "Anul viitor",
		last6Months: "Ultimele 6 luni",
		last12Months: "Ultimele 12 luni",
		last24Months: "Ultimele 24 de luni",
		andCondition: "ȘI",
		orCondition: "SAU",
		applyFilter: "Aplică",
		applyColumnToolPanel: "Aplică",
		resetFilter: "Resetează",
		clearFilter: "Curăță",
		cancelFilter: "Anulează",
		cancelColumnToolPanel: "Anulează",
		textFilter: "Filtru text",
		numberFilter: "Filtru număr",
		dateFilter: "Filtru dată",
		setFilter: "Filtru set",
		groupFilterSelect: "Selectează câmp:",
		filterSummaryInactive: "este (Toate)",
		filterSummaryContains: "conține",
		filterSummaryNotContains: "nu conține",
		filterSummaryTextEquals: "este egal cu",
		filterSummaryTextNotEqual: "nu este egal cu",
		filterSummaryStartsWith: "începe cu",
		filterSummaryEndsWith: "se termină cu",
		filterSummaryBlank: "este gol",
		filterSummaryNotBlank: "nu este gol",
		filterSummaryEquals: "=",
		filterSummaryNotEqual: "!=",
		filterSummaryGreaterThan: ">",
		filterSummaryGreaterThanOrEqual: ">=",
		filterSummaryLessThan: "<",
		filterSummaryLessThanOrEqual: "<=",
		filterSummaryInRange: "între",
		filterSummaryInRangeValues: "(${variable}, ${variable})",
		filterSummaryTextQuote: "\"${variable}\"",
		filterSummaryListInactive: "este (Toate)",
		filterSummaryListSeparator: ", ",
		filterSummaryListShort: "este (${variable})",
		filterSummaryListLong: "este (${variable}) și ${variable} mai mult",
		addFilterCard: "Adaugă filtru",
		agTextColumnFilterDisplayName: "Filtru simplu",
		agNumberColumnFilterDisplayName: "Filtru simplu",
		agDateColumnFilterDisplayName: "Filtru simplu",
		agSetColumnFilterDisplayName: "Filtru de selecție",
		agMultiColumnFilterDisplayName: "Filtru combinat",
		addFilterPlaceholder: "Caută coloane...",
		advancedFilterContains: "conține",
		advancedFilterNotContains: "nu conține",
		advancedFilterTextEquals: "egal",
		advancedFilterTextNotEqual: "nu este egal",
		advancedFilterStartsWith: "începe cu",
		advancedFilterEndsWith: "se termină cu",
		advancedFilterBlank: "este gol",
		advancedFilterNotBlank: "nu este gol",
		advancedFilterEquals: "=",
		advancedFilterNotEqual: "!=",
		advancedFilterGreaterThan: ">",
		advancedFilterGreaterThanOrEqual: ">=",
		advancedFilterLessThan: "<",
		advancedFilterLessThanOrEqual: "<=",
		advancedFilterTrue: "este adevărat",
		advancedFilterFalse: "este fals",
		advancedFilterAnd: "ȘI",
		advancedFilterOr: "SAU",
		advancedFilterApply: "Aplică",
		advancedFilterReset: "Resetare",
		advancedFilterCancel: "Anulează",
		advancedFilterClear: "Șterge",
		advancedFilterBuilder: "Constructor",
		advancedFilterValidationMissingColumn: "Lipsă coloană",
		advancedFilterValidationMissingOption: "Lipsă opțiune",
		advancedFilterValidationMissingValue: "Lipsă valoare",
		advancedFilterValidationInvalidColumn: "Coloană negăsită",
		advancedFilterValidationInvalidOption: "Opțiune negăsită",
		advancedFilterValidationMissingQuote: "Valorii îi lipsesc ghilimelele de încheiere",
		advancedFilterValidationNotANumber: "Valoarea nu este un număr",
		advancedFilterValidationInvalidDate: "Valoarea nu este o dată validă",
		advancedFilterValidationMissingCondition: "Lipsă condiție",
		advancedFilterValidationJoinOperatorMismatch: "Operatorii de unire din cadrul unei condiții trebuie să fie aceiași",
		advancedFilterValidationInvalidJoinOperator: "Operator de unire negăsit",
		advancedFilterValidationMissingEndBracket: "Lipsă paranteză de încheiere",
		advancedFilterValidationExtraEndBracket: "Prea multe paranteze de încheiere",
		advancedFilterValidationMessage: "Expresia are o eroare. ${variable} - ${variable}.",
		advancedFilterValidationMessageAtEnd: "Expresia are o eroare. ${variable} la sfârșitul expresiei.",
		advancedFilterBuilderTitle: "Filtru Avansat",
		advancedFilterBuilderApply: "Aplică",
		advancedFilterBuilderClear: "Șterge",
		advancedFilterBuilderReset: "Resetare",
		advancedFilterBuilderCancel: "Anulează",
		advancedFilterBuilderAddButtonTooltip: "Adaugă Filtru sau Grup",
		advancedFilterBuilderRemoveButtonTooltip: "Elimină",
		advancedFilterBuilderMoveUpButtonTooltip: "Mută În Sus",
		advancedFilterBuilderMoveDownButtonTooltip: "Mută În Jos",
		advancedFilterBuilderAddJoin: "Adaugă Grup",
		advancedFilterBuilderAddCondition: "Adaugă Filtru",
		advancedFilterBuilderSelectColumn: "Selectează o coloană",
		advancedFilterBuilderSelectOption: "Selectează o opțiune",
		advancedFilterBuilderEnterValue: "Introdu o valoare...",
		advancedFilterBuilderValidationAlreadyApplied: "Filtrul curent a fost deja aplicat.",
		advancedFilterBuilderValidationIncomplete: "Nu toate condițiile sunt complete.",
		advancedFilterBuilderValidationSelectColumn: "Trebuie să selectați o coloană.",
		advancedFilterBuilderValidationSelectOption: "Trebuie să selectați o opțiune.",
		advancedFilterBuilderValidationEnterValue: "Trebuie să introduceți o valoare.",
		minDateValidation: "Data trebuie să fie după ${variable}",
		maxDateValidation: "Data trebuie să fie înainte de ${variable}",
		maxLengthValidation: "Trebuie să fie cel mult ${variable} caractere.",
		minValueValidation: "Trebuie să fie mai mare sau egal cu ${variable}",
		maxValueValidation: "Trebuie să fie mai mic sau egal cu ${variable}",
		strictMinValueValidation: "Trebuie să fie mai mare decât ${variable}",
		strictMaxValueValidation: "Trebuie să fie mai mic decât ${variable}",
		invalidSelectionValidation: "Selecție invalidă.",
		invalidFormulaValidation: "Formulă invalidă.",
		formulaParseInvalidCellReference: "Referință de celulă invalidă: ${variable}.",
		formulaParseInvalidRangeEndReference: "Referință de sfârșit de interval invalidă.",
		formulaParseUnterminatedString: "Șir neterminat.",
		formulaParseUnexpectedCharacter: "Caracter neașteptat: ${variable}.",
		formulaParseOperatorStackUnderflow: "Subdepășire a stivei de operatori.",
		formulaParseMissingOperand: "Operand lipsă pentru '${variable}'.",
		formulaParseInternalUnexpectedFrameDuringReduction: "Eroare internă: cadru neașteptat în timpul reducerii.",
		formulaParseInternalUnexpectedFrameBeforeOpenParen: "Eroare internă: cadru neașteptat înainte de '('.",
		formulaParseMisplacedComma: "Virgulă plasată greșit.",
		formulaParseCommaOutsideFunctionCall: "Virgulă în afara unui apel de funcție.",
		formulaParseInternalUnexpectedFrameBeforeCloseParen: "Eroare internă: cadru neașteptat înainte de ')'.",
		formulaParseMismatchedParentheses: "Paranteze necorespunzătoare.",
		formulaParseUnsupportedOperand: "Operand neacceptat: ${variable}.",
		formulaParseMismatchedParenthesesOrUnfinishedFunctionCall: "Paranteze necorespunzătoare sau apel de funcție neterminat.",
		formulaParseInvalidExpression: "Expresie invalidă.",
		formulaParseFormulasMustBeginWithEquals: "Formulele trebuie să înceapă cu =.",
		formulaSerializeStringContainsQuote: "Șirul conține ghilimele (\") pe care tokenizatorul nu le acceptă.",
		formulaSerializeCannotProduceAbsoluteColumnLabelFromId: "Nu se poate produce eticheta absolută de COLOANĂ din id-ul '${variable}'.",
		formulaSerializeCannotProduceAbsoluteRowIndexFromId: "Nu se poate produce indexul absolut de RÂND din id-ul '${variable}'.",
		formulaSerializeCannotProduceRowIndexFromId: "Nu se poate produce indexul de RÂND din id-ul '${variable}'.",
		formulaSerializeCannotMapColumnIdToA1Label: "Nu se poate mapa id-ul coloanei '${variable}' la eticheta A1.",
		formulaSerializeCannotParseAbsoluteRowIndex: "Nu se poate analiza indexul absolut de rând '${variable}'.",
		formulaSerializeCannotMapRowIdToA1Index: "Nu se poate mapa id-ul rândului '${variable}' la indexul A1.",
		formulaEvalRangeNotAllowedInScalarContext: "Intervalul nu este permis în context scalar.",
		formulaEvalUnknownReferenceToCell: "Referință necunoscută la celulă.",
		formulaEvalUnsupportedOperation: "Operație neacceptată ${variable}.",
		formulaEvalInvalidAbsoluteRow: "Rând absolut invalid.",
		formulaEvalUnrecognisedRowId: "Id de rând nerecunoscut.",
		formulaEvalInvalidAbsoluteColumn: "Coloană absolută invalidă.",
		formulaEvalUnrecognisedColumnId: "Id de coloană nerecunoscut.",
		formulaEvalUnrecognisedRowInRange: "Rând nerecunoscut în interval.",
		formulaEvalUnrecognisedReferenceToCell: "Referință la celulă nerecunoscută.",
		formulaEvalIncompleteRangeReference: "Referință de interval incompletă.",
		formulaFunctionExpectedExactlyArguments: "${variable}: se așteptau exact ${variable} argumente.",
		formulaFunctionExpectedAtMostArguments: "${variable}: se așteptau cel mult ${variable} argumente.",
		formulaFunctionExpectedAtLeastArguments: "${variable}: se așteptau cel puțin ${variable} argumente.",
		formulaFunctionInvalidCriteriaWildcardsWithComparator: "Criteriu invalid: metacaractere cu operator de comparare.",
		formulaFunctionNonNumericArgument: "${variable}: argument nenumeric.",
		formulaFunctionDivisionByZero: "${variable}: împărțire la zero.",
		formulaFunctionCannotCombineDatesWithBigInt: "${variable}: nu se pot combina datele cu BigInt.",
		formulaFunctionRequiresAtLeastOneNumericValue: "${variable}: necesită cel puțin o valoare numerică.",
		formulaFunctionRequiresAtLeastOneValue: "${variable}: necesită cel puțin o valoare.",
		formulaFunctionAllValuesMustBeNumbers: "${variable}: toate valorile trebuie să fie numere.",
		formulaFunctionArgumentMustBeRange: "${variable}: argumentul ${variable} trebuie să fie un interval.",
		formulaFunctionArgumentMustBeValue: "${variable}: argumentul ${variable} trebuie să fie o valoare.",
		formulaFunctionRangesHaveDifferentSizes: "${variable}: intervalele au dimensiuni diferite.",
		formulaFunctionValuesMustBeNumeric: "${variable}: valorile trebuie să fie numerice.",
		formulaFunctionValuesMustBeIntegers: "${variable}: valorile trebuie să fie numere întregi.",
		formulaFunctionUnsupportedValueType: "${variable}: tip de valoare neacceptat.",
		formulaFunctionDivNonNumericArgument: "DIV: argument nenumeric.",
		formulaFunctionDivDivisionByZero: "DIV: împărțire la zero.",
		formulaFunctionSumCannotCombineDatesWithBigInt: "SUM: nu se pot combina datele cu BigInt.",
		formulaFunctionSumRequiresAtLeastOneNumericValue: "SUM: necesită cel puțin o valoare numerică.",
		formulaFunctionAvgRequiresAtLeastOneValue: "AVG: necesită cel puțin o valoare.",
		formulaFunctionMedianAllValuesMustBeNumbers: "MEDIAN: toate valorile trebuie să fie numere.",
		formulaFunctionMedianRequiresAtLeastOneValue: "MEDIAN: necesită cel puțin o valoare.",
		formulaFunctionSumifFirstArgumentMustBeRange: "SUMIF: primul argument trebuie să fie un interval.",
		formulaFunctionSumifSecondArgumentMustBeValue: "SUMIF: al doilea argument trebuie să fie o valoare (criteriu).",
		formulaFunctionSumifThirdArgumentMustBeRange: "SUMIF: al treilea argument trebuie să fie un interval (sum_range).",
		formulaFunctionSumifRangesHaveDifferentSizes: "SUMIF: intervalele au dimensiuni diferite.",
		formulaFunctionCountifFirstArgumentMustBeRange: "COUNTIF: primul argument trebuie să fie un interval.",
		formulaFunctionCountifSecondArgumentMustBeValue: "COUNTIF: al doilea argument trebuie să fie o valoare (criteriu).",
		formulaFunctionConcatUnsupportedValueType: "CONCAT: tip de valoare neacceptat.",
		formulaFunctionMinRequiresAtLeastOneValue: "MIN: necesită cel puțin o valoare.",
		formulaFunctionMaxRequiresAtLeastOneValue: "MAX: necesită cel puțin o valoare.",
		formulaFunctionPercentNonNumericArgument: "PERCENT: argument nenumeric.",
		formulaFunctionPowerNonNumericArgument: "POWER: argument nenumeric.",
		formulaServiceCircularReference: "Referință circulară.",
		formulaServiceExpectedParsableFormula: "Se aștepta o formulă care poate fi analizată.",
		formulaServiceInternalSchedulingError: "Eroare internă de planificare.",
		tooltipValidationErrorSeparator: ". ",
		columns: "Coloane",
		filters: "Filtre",
		pivotMode: "Mod Pivot",
		groups: "Grupuri de Rânduri",
		rowGroupColumnsEmptyMessage: "Trageți aici pentru a seta grupuri de rânduri",
		values: "Valori",
		valueColumnsEmptyMessage: "Trageți aici pentru a agrega",
		pivots: "Etichete de Coloane",
		pivotColumnsEmptyMessage: "Trageți aici pentru a seta etichete de coloane",
		group: "Grup",
		rowDragRow: "rând",
		rowDragRows: "rânduri",
		loadingOoo: "Se încarcă...",
		loadingError: "EROARE",
		noRowsToShow: "Niciun rând de afișat",
		noMatchingRows: "Niciun rând nu se potrivește",
		exportingOoo: "Se exportă...",
		enabled: "Activat",
		pinColumn: "Fixează Coloana",
		pinLeft: "Fixează la Stânga",
		pinRight: "Fixează la Dreapta",
		noPin: "Nu Fixa",
		pinRow: "Fixează rândul",
		pinTop: "Fixează în partea de sus",
		pinBottom: "Fixează în partea de jos",
		unpinRow: "Anulează fixarea rândului",
		valueAggregation: "Agregare Valori",
		noAggregation: "Niciuna",
		autosizeThisColumn: "Redimensionează automat această coloană",
		autosizeAllColumns: "Redimensionează automat toate coloanele",
		groupBy: "Grupează după ${variable}",
		ungroupBy: "Degrupează după ${variable}",
		ungroupAll: "Degrupează tot",
		addToValues: "Adaugă ${variable} la valori",
		removeFromValues: "Elimină ${variable} din valori",
		addToLabels: "Adaugă ${variable} la etichete",
		removeFromLabels: "Elimină ${variable} din etichete",
		resetColumns: "Resetează coloanele",
		expandAll: "Extinde toate grupurile de rânduri",
		collapseAll: "Restrânge toate grupurile de rânduri",
		copy: "Copiază",
		ctrlC: "Ctrl+C",
		ctrlX: "Ctrl+X",
		copyWithHeaders: "Copiază cu Antete",
		copyWithGroupHeaders: "Copiază cu Antete de Grup",
		cut: "Taie",
		paste: "Lipește",
		ctrlV: "Ctrl+V",
		export: "Exportă",
		csvExport: "Exportă CSV",
		excelExport: "Exportă Excel",
		columnFilter: "Filtru de Coloană",
		columnChooser: "Alege Coloane",
		chooseColumns: "Alege Coloane",
		sortAscending: "Sortare Ascendentă",
		sortDescending: "Sortare Descendentă",
		sortAbsoluteAscending: "Sortează în ordine ascendentă absolută",
		sortAbsoluteDescending: "Sortează în ordine descendentă absolută",
		sortUnSort: "Șterge Sortarea",
		shiftF2: "Shift+F2",
		toolbarFind: "Caută",
		toolbarFindPreviousMatch: "Potrivire Anterioară",
		toolbarFindNextMatch: "Potrivire Următoare",
		toolbarQuickFilter: "Filtru",
		toolbarMenu: "Meniu",
		sum: "Sumă",
		first: "Primul",
		last: "Ultimul",
		min: "Minim",
		max: "Maxim",
		none: "Niciunul",
		count: "Numărătoare",
		avg: "Medie",
		filteredRows: "Filtrate",
		selectedRows: "Selectate",
		totalRows: "Total Rânduri",
		totalAndFilteredRows: "Rânduri",
		more: "Mai mult",
		to: "la",
		of: "din",
		page: "Pagină",
		pageLastRowUnknown: "?",
		nextPage: "Pagina Următoare",
		lastPage: "Ultima Pagină",
		firstPage: "Prima Pagină",
		previousPage: "Pagina Anterioară",
		pageSizeSelectorLabel: "Mărime Pagină:",
		footerTotal: "Total",
		statusBarLastRowUnknown: "?",
		scrollColumnIntoView: "Derulează ${variable} în vizualizare",
		pivotColumnGroupTotals: "Total",
		pivotChartAndPivotMode: "Pivot Chart și Modul Pivot",
		pivotChart: "Pivot Chart",
		chartRange: "Interval Grafic",
		columnChart: "Coloană",
		groupedColumn: "Grupat",
		stackedColumn: "Stivuit",
		normalizedColumn: "100% Stivuit",
		barChart: "Bară",
		groupedBar: "Grupat",
		stackedBar: "Stivuit",
		normalizedBar: "100% Stivuit",
		pieChart: "Plăcintă",
		pie: "Plăcintă",
		donut: "Gogoașă",
		lineChart: "Linie",
		stackedLine: "Stivuit",
		normalizedLine: "100% Stivuit",
		xyChart: "X Y (Puncte dispersate)",
		scatter: "Puncte dispersate",
		bubble: "Bule",
		areaChart: "Zonă",
		area: "Zonă",
		stackedArea: "Stivuit",
		normalizedArea: "100% Stivuit",
		histogramChart: "Histogramă",
		polarChart: "Polar",
		radarLine: "Linie Radar",
		radarArea: "Zonă Radar",
		nightingale: "Nightingale",
		radialColumn: "Coloană Radială",
		radialBar: "Bară Radială",
		statisticalChart: "Statistic",
		boxPlot: "Grafic Box",
		rangeBar: "Bară Interval",
		rangeArea: "Zonă Interval",
		hierarchicalChart: "Ierarhic",
		treemap: "Hartă Arbore",
		sunburst: "Explozie Solară",
		specializedChart: "Specializat",
		waterfall: "Cascadă",
		heatmap: "Hartă Termică",
		combinationChart: "Combinată",
		columnLineCombo: "Coloană și Linie",
		AreaColumnCombo: "Zonă și Coloană",
		pivotChartTitle: "Grafic Pivot",
		rangeChartTitle: "Grafic Interval",
		settings: "Setări",
		data: "Date",
		format: "Format",
		categories: "Categorii",
		defaultCategory: "(Niciunul)",
		series: "Serii",
		switchCategorySeries: "Schimbare Categorie / Serii",
		categoryValues: "Valori Categorie",
		seriesLabels: "Etichete Serii",
		aggregate: "Agregat",
		xyValues: "Valori X Y",
		paired: "Mod Pereche",
		axis: "Axă",
		xAxis: "Axă Orizontală",
		yAxis: "Axă Verticală",
		polarAxis: "Axă Polară",
		radiusAxis: "Axă Radius",
		navigator: "Navigator",
		zoom: "Zoom",
		animation: "Animație",
		crosshair: "Reticul",
		color: "Culoare",
		thickness: "Grosime",
		preferredLength: "Lungime preferată",
		xType: "Tip X",
		axisType: "Tip Axă",
		automatic: "Automat",
		category: "Categorie",
		number: "Număr",
		time: "Timp",
		timeFormat: "Format Timp",
		autoRotate: "Rotație automată",
		labelRotation: "Rotație",
		circle: "Cerc",
		polygon: "Poligon",
		square: "Pătrat",
		cross: "Cruce",
		diamond: "Diamant",
		plus: "Plus",
		triangle: "Triunghi",
		heart: "Inimă",
		orientation: "Orientare",
		fixed: "Fix",
		parallel: "Paralel",
		perpendicular: "Perpendicular",
		radiusAxisPosition: "Poziție",
		ticks: "Marcaje",
		gridLines: "Linii Grilă",
		width: "Lățime",
		height: "Înălțime",
		length: "Lungime",
		padding: "Padding",
		spacing: "Spațiere",
		chartStyle: "Stil Grafic",
		title: "Titlu",
		chartTitles: "Titluri",
		chartTitle: "Titlu Grafic",
		chartSubtitle: "Subtitlu",
		horizontalAxisTitle: "Titlu Axă Orizontală",
		verticalAxisTitle: "Titlu Axă Verticală",
		polarAxisTitle: "Titlu Axă Polară",
		titlePlaceholder: "Titlu Grafic",
		background: "Fundal",
		font: "Font",
		weight: "Greutate",
		top: "Deasupra",
		right: "Dreapta",
		bottom: "Dedesubt",
		left: "Stânga",
		labels: "Etichete",
		calloutLabels: "Etichete Apel",
		sectorLabels: "Etichete Sector",
		positionRatio: "Raport Poziție",
		size: "Mărime",
		shape: "Formă",
		minSize: "Mărime Minimă",
		maxSize: "Mărime Maximă",
		legend: "Legendă",
		position: "Poziție",
		markerSize: "Mărime Marcaj",
		markerStroke: "Tușe Marcaj",
		markerPadding: "Padding Marcaj",
		itemSpacing: "Spațiere Elemente",
		itemPaddingX: "Padding Element X",
		itemPaddingY: "Padding Element Y",
		layoutHorizontalSpacing: "Spațiere Orizontală",
		layoutVerticalSpacing: "Spațiere Verticală",
		strokeWidth: "Grosime Linie",
		offset: "Offset",
		offsets: "Offset-uri",
		tooltips: "Tooltip-uri",
		callout: "Apel",
		markers: "Marcaje",
		shadow: "Umbră",
		blur: "Estompare",
		xOffset: "Offset X",
		yOffset: "Offset Y",
		lineWidth: "Grosime Linie",
		lineDash: "Linie Punctată",
		lineDashOffset: "Offset Linie Punctată",
		scrollingZoom: "Defilare",
		scrollingStep: "Pas Defilare",
		selectingZoom: "Selectare",
		durationMillis: "Durată (ms)",
		crosshairLabel: "Etichetă",
		crosshairSnap: "Fixare pe Nod",
		normal: "Normal",
		bold: "Aldin",
		italic: "Italic",
		boldItalic: "Aldin Italic",
		predefined: "Predefinit",
		fillOpacity: "Opacitate Umplere",
		strokeColor: "Culoare Linie",
		strokeOpacity: "Opacitate Linie",
		miniChart: "Mini-Grafic",
		histogramBinCount: "Număr Benzi",
		connectorLine: "Linie Conectare",
		seriesItems: "Elemente Serii",
		seriesItemType: "Tip Element",
		seriesItemPositive: "Pozitiv",
		seriesItemNegative: "Negativ",
		seriesItemLabels: "Etichete Elemente",
		columnGroup: "Coloană",
		barGroup: "Bară",
		pieGroup: "Plăcintă",
		lineGroup: "Linie",
		scatterGroup: "X Y (Dispersie)",
		areaGroup: "Zonă",
		polarGroup: "Polar",
		statisticalGroup: "Statistic",
		hierarchicalGroup: "Ierarhic",
		specializedGroup: "Specializat",
		combinationGroup: "Combinație",
		groupedColumnTooltip: "Grupat",
		stackedColumnTooltip: "Stivuit",
		normalizedColumnTooltip: "100% Stivuit",
		groupedBarTooltip: "Grupat",
		stackedBarTooltip: "Stivuit",
		normalizedBarTooltip: "100% Stivuit",
		pieTooltip: "Plăcintă",
		donutTooltip: "Gogoașă",
		lineTooltip: "Linie",
		stackedLineTooltip: "Stivuit",
		normalizedLineTooltip: "100% Stivuit",
		groupedAreaTooltip: "Grupat",
		stackedAreaTooltip: "Stivuit",
		normalizedAreaTooltip: "100% Stivuit",
		scatterTooltip: "Dispersie",
		bubbleTooltip: "Bulă",
		histogramTooltip: "Histogramă",
		radialColumnTooltip: "Coloană Radială",
		radialBarTooltip: "Bară Radială",
		radarLineTooltip: "Linie Radar",
		radarAreaTooltip: "Zonă Radar",
		nightingaleTooltip: "Nightingale",
		rangeBarTooltip: "Bară Interval",
		rangeAreaTooltip: "Zonă Interval",
		boxPlotTooltip: "Box Plot",
		treemapTooltip: "Hartă Arbore",
		sunburstTooltip: "Sunburst",
		waterfallTooltip: "Cascadă",
		heatmapTooltip: "Hartă Termică",
		columnLineComboTooltip: "Coloană & Linie",
		areaColumnComboTooltip: "Zonă & Coloană",
		customComboTooltip: "Combinație Personalizată",
		innerRadius: "Raza Interioară",
		startAngle: "Unghi de Start",
		endAngle: "Unghi de Sfârșit",
		reverseDirection: "Direcție Inversă",
		groupPadding: "Padding Grup",
		seriesPadding: "Padding Serii",
		tile: "Placă",
		whisker: "Mustață",
		cap: "Capac",
		capLengthRatio: "Raport Lungime Capac",
		labelPlacement: "Plasament Etichetă",
		inside: "În Interior",
		outside: "În Exterior",
		noDataToChart: "Nu sunt date disponibile pentru grafic.",
		pivotChartRequiresPivotMode: "Graficul Pivot necesită activarea Modului Pivot.",
		chartSettingsToolbarTooltip: "Meniu",
		chartLinkToolbarTooltip: "Legat la Grila",
		chartUnlinkToolbarTooltip: "Nelegat de Grilă",
		chartDownloadToolbarTooltip: "Descărcare Grafic",
		chartMenuToolbarTooltip: "Meniu",
		chartEdit: "Editare Grafic",
		chartAdvancedSettings: "Setări Avansate",
		chartLink: "Legare la Grilă",
		chartUnlink: "Dezlegare de Grilă",
		chartDownload: "Descărcare Grafic",
		histogramFrequency: "Frecvență",
		seriesChartType: "Tip Grafic Serii",
		seriesType: "Tip Serii",
		secondaryAxis: "Axă Secundară",
		seriesAdd: "Adăugați o serie",
		categoryAdd: "Adăugați o categorie",
		bar: "Bară",
		column: "Coloană",
		histogram: "Histogramă",
		advancedSettings: "Setări Avansate",
		direction: "Direcție",
		horizontal: "Orizontal",
		vertical: "Vertical",
		seriesGroupType: "Tip Grup",
		groupedSeriesGroupType: "Grupat",
		stackedSeriesGroupType: "Stivuit",
		normalizedSeriesGroupType: "100% Stivuit",
		legendEnabled: "Activat",
		invalidColor: "Valoarea culorii este invalidă",
		groupedColumnFull: "Coloană Grupată",
		stackedColumnFull: "Coloană Stivuită",
		normalizedColumnFull: "Coloană 100% Stivuită",
		groupedBarFull: "Bară Grupată",
		stackedBarFull: "Bară Stivuită",
		normalizedBarFull: "Bară 100% Stivuită",
		stackedAreaFull: "Zonă Stivuită",
		normalizedAreaFull: "Zonă 100% Stivuită",
		customCombo: "Combinație Personalizată",
		funnel: "Pâlnie",
		coneFunnel: "Pâlnie Con",
		pyramid: "Piramidă",
		funnelGroup: "Grup Pâlnie",
		funnelTooltip: "Pâlnie",
		coneFunnelTooltip: "Pâlnie Con",
		pyramidTooltip: "Piramidă",
		dropOff: "Scădere",
		stageLabels: "Etichete Etapă",
		reverse: "Invers",
		tooltipMode: "Mod Tooltip",
		tooltipModeSingle: "Unic",
		tooltipModeShared: "Partajat",
		tooltipModeCompact: "Compact",
		ariaAdvancedFilterBuilderItem: "${variable}. Nivel ${variable}. Apăsați ENTER pentru a edita.",
		ariaAdvancedFilterBuilderItemValidation: "${variable}. Nivel ${variable}. ${variable} Apăsați ENTER pentru a edita.",
		ariaAdvancedFilterBuilderList: "Lista Constructorului de Filtre Avansate",
		ariaAdvancedFilterBuilderFilterItem: "Condiție de Filtrare",
		ariaAdvancedFilterBuilderGroupItem: "Grup de Filtre",
		ariaAdvancedFilterBuilderColumn: "Coloană",
		ariaAdvancedFilterBuilderOption: "Opțiune",
		ariaAdvancedFilterBuilderValueP: "Valoare",
		ariaAdvancedFilterBuilderJoinOperator: "Operator de Îmbinare",
		ariaAdvancedFilterInput: "Intrare Filtru Avansat",
		ariaChecked: "bifat",
		ariaColumn: "Coloană",
		ariaColumnGroup: "Grup de Coloane",
		ariaFilterActive: "Filtru activ",
		ariaColumnFiltered: "Coloană Filtrată",
		ariaColumnSelectAll: "Comută vizibilitatea tuturor coloanelor",
		ariaDateFilterInput: "Intrare Filtru de Dată",
		ariaDefaultListName: "Listă",
		ariaFilterColumnsInput: "Intrare Filtrare Coloane",
		ariaFilterFromValue: "Filtrează de la valoare",
		ariaFilterInput: "Intrare Filtru",
		ariaFilterList: "Listă de Filtre",
		ariaFilterToValue: "Filtrează până la valoare",
		ariaFilterValue: "Valoare Filtrată",
		ariaFilterMenuOpen: "Deschide Meniul Filtrului",
		ariaFilteringOperator: "Operator de Filtrare",
		ariaHidden: "ascuns",
		ariaIndeterminate: "nedeterminat",
		ariaInputEditor: "Editor Intrare",
		ariaMenuColumn: "Apăsați ALT în jos pentru a deschide meniul coloanei",
		ariaFilterColumn: "Apăsați CTRL ENTER pentru a deschide filtrul",
		ariaRowDeselect: "Apăsați SPACE pentru a deselecta acest rând",
		ariaHeaderSelection: "Coloană cu selecție antet",
		ariaSelectAllCells: "Apăsați Space sau Enter pentru a selecta toate celulele",
		ariaSelectAllRowCells: "Apăsați Enter pentru a selecta toate celulele din acest rând",
		ariaColumnCellSelection: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din această coloană",
		ariaColumnGroupCellSelection: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane",
		ariaColumnGroupExpansion: "Apăsați ENTER pentru a extinde sau restrânge acest grup de coloane",
		ariaColumnGroupCellSelectionAndExpansion: "Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane. Apăsați ALT ENTER pentru a extinde sau restrânge acest grup de coloane",
		ariaRowSelectAll: "Apăsați Space pentru a comuta selecția tuturor rândurilor",
		ariaRowToggleSelection: "Apăsați Space pentru a comuta selecția rândului",
		ariaRowSelect: "Apăsați SPACE pentru a selecta acest rând",
		ariaRowSelectionDisabled: "Selecția rândului este dezactivată pentru acest rând",
		ariaSearch: "Căutare",
		ariaSortableColumn: "Apăsați ENTER pentru a sorta",
		ariaSortableColumnWithCellSelection: "Apăsați ALT ENTER pentru a sorta",
		ariaToggleVisibility: "Apăsați SPACE pentru a comuta vizibilitatea",
		ariaToggleCellValue: "Apăsați SPACE pentru a comuta valoarea celulei",
		ariaUnchecked: "nebifat",
		ariaVisible: "vizibil",
		ariaSearchFilterValues: "Caută valori ale filtrului",
		ariaPageSizeSelectorLabel: "Dimensiunea Paginii",
		ariaChartMenuClose: "Închide meniul de editare a graficului",
		ariaChartSelected: "Selectat",
		ariaSparklineChartDescription: "Sparkline - ${chartType} afișează ${count} valori între ${min} și ${max}. Începe la ${start} și se termină la ${end}.",
		ariaSparklineChartDescriptionSingleValue: "Sparkline - ${chartType} afișează 1 valoare: ${value}.",
		ariaSparklineChartDescriptionEmpty: "Sparkline - ${chartType} fără valori.",
		ariaSkeletonCellLoadingFailed: "Încărcarea rândului a eșuat",
		ariaSkeletonCellLoading: "Datele rândului se încarcă",
		ariaDeferSkeletonCellLoading: "Celula se încarcă",
		ariaPendingChange: "Modificare în așteptare",
		ariaRowGroupDropZonePanelLabel: "Grupuri de rânduri",
		ariaValuesDropZonePanelLabel: "Valori",
		ariaPivotDropZonePanelLabel: "Etichete de coloană",
		ariaDropZoneColumnComponentDescription: "Apăsați DELETE pentru a elimina",
		ariaDropZoneColumnValueItemDescription: "Apăsați ENTER pentru a schimba tipul de agregare",
		ariaDropZoneColumnGroupItemDescription: "Apăsați ENTER pentru a sorta",
		ariaDropZoneColumnComponentAggFuncSeparator: " din ",
		ariaDropZoneColumnComponentSortAscending: "crescător",
		ariaDropZoneColumnComponentSortDescending: "descrescător",
		ariaDropZoneColumnComponentSortAbsoluteAscending: "ascendent absolut",
		ariaDropZoneColumnComponentSortAbsoluteDescending: "descendent absolut",
		ariaLabelDialog: "Dialog",
		ariaLabelColumnMenu: "Meniu Coloană",
		ariaLabelColumnFilter: "Filtru Coloană",
		ariaLabelSelectField: "Selectează Câmp",
		ariaValidationErrorPrefix: "Validare editor de celule",
		ariaLabelLoadingContextMenu: "Încărcare Meniu Contextual",
		ariaLabelRichSelectField: "Câmp Selectare Avansată",
		ariaLabelRichSelectToggleSelection: "Apăsați SPACE pentru a comuta selecția",
		ariaLabelRichSelectDeselectAllItems: "Apăsați DELETE pentru a deselecta toate elementele",
		ariaLabelRichSelectDeleteSelection: "Apăsați DELETE pentru a deselecta elementul",
		ariaLabelTooltip: "Sugestie",
		ariaLabelContextMenu: "Meniu Contextual",
		ariaLabelSubMenu: "Submeniu",
		ariaLabelAggregationFunction: "Funcția de Agregare",
		ariaLabelAdvancedFilterAutocomplete: "Autocompletare Filtru Avansat",
		ariaLabelAdvancedFilterBuilderAddField: "Constructor Filtru Avansat - Adăugare Câmp",
		ariaLabelAdvancedFilterBuilderColumnSelectField: "Constructor Filtru Avansat - Selectare Coloană Câmp",
		ariaLabelAdvancedFilterBuilderOptionSelectField: "Constructor Filtru Avansat - Selectare Opțiune Câmp",
		ariaLabelAdvancedFilterBuilderJoinSelectField: "Constructor Filtru Avansat - Selectare Operator De Unire Câmp",
		ariaColumnPanelList: "Listă de coloane",
		ariaFilterPanelList: "Listă de filtre",
		ariaLabelAddFilterField: "Adaugă Câmp de Filtrare",
		ariaLabelFilterCardDelete: "Șterge Filtrul",
		ariaLabelFilterCardHasEdits: "Are Modificări",
		ariaHasNote: "Această celulă are o notă.",
		thousandSeparator: ",",
		decimalSeparator: ".",
		true: "Adevărat",
		false: "Fals",
		invalidDate: "Dată invalidă",
		invalidNumber: "Număr invalid",
		invalidBigInt: "BigInt invalid",
		january: "Ianuarie",
		february: "Februarie",
		march: "Martie",
		april: "Aprilie",
		may: "Mai",
		june: "Iunie",
		july: "Iulie",
		august: "August",
		september: "Septembrie",
		october: "Octombrie",
		november: "Noiembrie",
		december: "Decembrie",
		year: "An",
		quarter: "Trimestru",
		month: "Lună",
		day: "Zi",
		hour: "Oră",
		minute: "Minut",
		second: "Secundă",
		timeFormatSlashesDDMMYYYY: "ZZ/LL/AAAA",
		timeFormatSlashesMMDDYYYY: "LL/ZZ/AAAA",
		timeFormatSlashesDDMMYY: "ZZ/LL/AA",
		timeFormatSlashesMMDDYY: "LL/ZZ/AA",
		timeFormatDotsDDMYY: "ZZ.L.AA",
		timeFormatDotsMDDYY: "L.ZZ.AA",
		timeFormatDashesYYYYMMDD: "AAAA-LL-ZZ",
		timeFormatSpacesDDMMMMYYYY: "ZZ LLLL AAAA",
		timeFormatHHMMSS: "OO:MM:SS",
		timeFormatHHMMSSAmPm: "OO:MM:SS AM/PM",
		note: "Notă celulă",
		addNote: "Adaugă notă",
		viewNote: "Vizualizează nota",
		editNote: "Editează nota",
		deleteNote: "Elimină nota",
		notePlaceholder: "Adaugă o notă..."
	},
	ru: {
		selectAll: "Выбрать все",
		selectAllSearchResults: "Выбрать все результаты поиска",
		addFilter: "Добавить фильтр",
		clearFilter: "Очистить фильтр",
		applyFilter: "Применить фильтр",
		resetFilter: "Сбросить",
		searchOoo: "Поиск...",
		equals: "Равно",
		notEqual: "Не равно",
		lessThan: "Меньше чем",
		greaterThan: "Больше чем",
		greaterThanOrEqual: "Больше или равно",
		lessThanOrEqual: "Меньше или равно",
		inRange: "В диапазоне",
		inRangeStart: "В диапазоне (начало)",
		inRangeEnd: "В диапазоне (конец)",
		contains: "Содержит",
		notContains: "Не содержит",
		startsWith: "Начинается с",
		endsWith: "Заканчивается на",
		before: "До",
		after: "После",
		andCondition: "И",
		orCondition: "Или",
		and: "И",
		or: "Или",
		not: "Не",
		is: "Является",
		isNot: "Не является",
		isEmpty: "Пусто",
		isNotEmpty: "Не пусто",
		isNull: "NULL",
		isNotNull: "Не NULL",
		isBlank: "Пусто",
		isNotBlank: "Не пусто",
		filterOoo: "Фильтр...",
		blanks: "Пустые значения",
		blank: "Пустое значение",
		notBlank: "Не пустое значение",
		dateFormatOoo: "yyyy-mm-dd",
		copy: "Копировать",
		paste: "Вставить",
		export: "Экспорт",
		csvExport: "Экспорт CSV",
		excelExport: "Экспорт Excel",
		pageSizeSelectorLabel: "Размер страницы",
		page: "Страница",
		more: "Больше",
		to: "до",
		of: "из",
		next: "Следующая",
		last: "Последняя",
		first: "Первая",
		previous: "Предыдущая",
		loadingOoo: "Загрузка...",
		columns: "Столбцы",
		filters: "Фильтры",
		group: "Группа",
		rowGroupColumnsEmptyMessage: "Перетащите сюда столбцы для группировки",
		valueColumnsEmptyMessage: "Перетащите сюда столбцы для значений",
		noRowsToShow: "Нет данных для отображения",
		pinColumn: "Закрепить столбец",
		autosizeThiscolumn: "Автоматический размер",
		resetColumns: "Сбросить столбцы",
		expandAll: "Развернуть все",
		collapseAll: "Свернуть все",
		sum: "Сумма",
		min: "Минимум",
		max: "Максимум",
		none: "Нет",
		count: "Количество",
		avg: "Среднее"
	},
	sk: $e,
	sv: Qe,
	tr: et,
	uk: tt,
	ur: Ye,
	uz: {
		selectAll: "Hammasini tanlash",
		selectAllSearchResults: "Qidiruv natijalarini tanlash",
		addFilter: "Filtr qo‘shish",
		clearFilter: "Filtrni tozalash",
		applyFilter: "Filtrni qo‘llash",
		resetFilter: "Tiklash",
		searchOoo: "Qidiruv...",
		equals: "Teng",
		notEqual: "Teng emas",
		lessThan: "Kichikroq",
		greaterThan: "Kattaroq",
		lessThanOrEqual: "Kichik yoki teng",
		greaterThanOrEqual: "Katta yoki teng",
		inRange: "Diapazonda",
		inRangeStart: "Diapazonda (bosh)",
		inRangeEnd: "Diapazonda (oxir)",
		contains: "O‘z ichiga oladi",
		notContains: "O‘z ichiga olmaydi",
		startsWith: "Boshida",
		endsWith: "Tugada",
		before: "Oldin",
		after: "Keyin",
		andCondition: "Va",
		orCondition: "Yoki",
		and: "Va",
		or: "Yoki",
		not: "Yo‘q",
		is: "Ijobiy",
		isNot: "Manfiy",
		isEmpty: "Bo‘sh",
		isNotEmpty: "Bo‘sh emas",
		isNull: "NULL",
		isNotNull: "NULL emas",
		isBlank: "Bo‘sh",
		isNotBlank: "Bo‘sh emas",
		filterOoo: "Filtr...",
		blanks: "Bo‘sh joylar",
		blank: "Bo‘sh joy",
		notBlank: "Bo‘sh joy emas",
		dateFormatOoo: "yyyy-mm-dd",
		copy: "Nusxa olish",
		paste: "Joylashtirish",
		export: "Eksport",
		csvExport: "CSV eksport",
		excelExport: "Excel eksport",
		pageSizeSelectorLabel: "Sahifa o‘lchami",
		page: "Sahifa",
		more: "Ko‘proq",
		to: "dan",
		of: "jami",
		next: "Keyingi",
		last: "Oxirgi",
		first: "Birinchi",
		previous: "Oldingi",
		loadingOoo: "Yuklanmoqda...",
		columns: "Ustunlar",
		filters: "Filtrlar",
		group: "Guruh",
		rowGroupColumnsEmptyMessage: "Guruhlash uchun ustunni shu yerga torting",
		valueColumnsEmptyMessage: "Qiymatlar uchun ustunni shu yerga torting",
		noRowsToShow: "Ko‘rsatish uchun ma’lumot yo‘q",
		pinColumn: "Ustunni mahkamlash",
		autosizeThiscolumn: "Ustunni avtomatik o‘lchash",
		resetColumns: "Ustunlarni tiklash",
		expandAll: "Barchasini yoyish",
		collapseAll: "Barchasini yig‘ish",
		sum: "Yig‘indi",
		min: "Minimum",
		max: "Maksimum",
		none: "Yo‘q",
		count: "Soni",
		avg: "O‘rtacha"
	},
	vi: nt,
	zh: je
}, Dt = (e) => e ? Et[e] : void 0, Ot = () => /* @__PURE__ */ Q(Z, { name: "search" }), kt = ({ view: t, enumerations: i, language: o, style: l, className: u, templateConfig: f }) => {
	let p = s(f);
	p.current = f;
	let m = a(() => H(() => p.current), []), h = s(void 0), [g, _] = c(() => De(t) ? st(t.columns, i) : void 0), [y, b] = c(!1), [x, S] = c(d), [C, w] = c(!1), T = s(!0), E = e(), { pageNumber: D, totalNumberOfRows: O, pagedTasks: k, setFilters: A, setSort: j, onKeywordChange: M, onPageNumberChange: N, onSelectedTaskChanged: P, selectedTaskWithDetails: F, selectedTasks: ee, setSelectedTasks: I, onBulkTaskActionUpdate: R, searchBulkAssignees: z } = yt(t, i, x, m), B = q(K.Input), V = q(K.Table), U = q(K.TableHeader), re = q(K.Modal), W = a(() => k[D] || [], [k, D]), ie = a(() => pt(W), [W]), J = t?.rowSelectionEnabled ?? !0, Y = a(() => J ? { mode: "multiRow" } : void 0, [J]), ae = !l?.height || l.height === "auto", oe = a(() => ({
		localeText: Dt(o),
		...ae ? { domLayout: "autoHeight" } : {}
	}), [o, ae]), se = (e) => {
		h.current = e.api;
	}, ce = n(({ newPage: e, newPageSize: t }) => {
		if (h.current && t ? m.pageSizeChanged() : h.current && e && m.paged(h.current.paginationGetCurrentPage()), h.current && e) {
			let e = h.current.paginationGetCurrentPage();
			N(e);
		}
		h.current && t && S(h.current.paginationGetPageSize());
	}, [N, m]), le = n((e) => {
		let n = ft(e.api.getFilterModel(), t?.columns);
		A(n), e.source === "api" ? m.gridReset(e.api.getFilterModel()) : m.filtered(e.api.getFilterModel(), (t) => e.api.getColumn(t)?.getColDef().headerName), N(0);
	}, [
		t,
		A,
		N,
		m
	]), fe = n((e) => {
		let t = e?.columns?.find((e) => e.getSort()) ?? e?.columns?.[0];
		e?.source !== "gridOptionsChanged" && m.sorted(t?.getColDef().headerName, t?.getSort());
		let n = te(e.api);
		_((e) => e?.map((e) => {
			let t = n.find(({ colId: t }) => t === e.field);
			return {
				...e,
				sort: t?.sort ?? null,
				sortIndex: t?.sortIndex ?? null
			};
		})), j(ne(n));
	}, [j, m]), pe = n((e) => {
		e.rowIndex !== null && (m.taskOpened(W[e.rowIndex - D * x]?.processInstance?.processState), I([]), h.current?.deselectAll(), P(e.rowIndex), b(!0));
	}, [
		P,
		W,
		D,
		x,
		m
	]), me = n((e) => {
		let t = e.api.getSelectedRows().map(({ agGridId: e }) => e), n = W.filter(({ tokenUuid: e }) => t.includes(e));
		I(n);
	}, [W]), ge = n((e, t) => {
		w(!0), R(e, t).then(() => {
			w(!1);
		}), h.current?.deselectAll();
	}, [R]), _e = k[0] !== void 0;
	return r(() => {
		_e && m.opened();
	}, [_e, m]), r(() => {
		if (!h.current || isNaN(D)) return;
		let e = h.current.paginationGetCurrentPage();
		D !== e && h.current.paginationGoToPage(D);
	}, [D]), r(() => {
		if (T.current) {
			T.current = !1;
			return;
		}
		De(t) && _(st(t.columns, i));
	}, [t, i]), /* @__PURE__ */ $(we, { children: [/* @__PURE__ */ $("div", {
		className: G("flx-task-management-container", u),
		style: l,
		children: [
			/* @__PURE__ */ Q("div", {
				className: "flx-task-search",
				children: /* @__PURE__ */ Q(ue, {
					className: G(B, "flx-search-input"),
					children: /* @__PURE__ */ Q(ve, {
						prefixIcon: Ot,
						children: /* @__PURE__ */ Q(X, {
							placeholder: `${L("@@sys_search")}...`,
							onChange: (e) => M(e.target.value)
						})
					})
				})
			}),
			J ? /* @__PURE__ */ Q(Tt, {
				tasks: ee,
				onUpdateTasks: ge,
				searchUsers: z
			}) : null,
			/* @__PURE__ */ Q("div", {
				className: "flx-table-wrapper",
				children: /* @__PURE__ */ Q(Ce, {
					gridOptions: oe,
					isServerSide: !0,
					totalNumberOfRows: O,
					rowData: ie,
					columnDefs: g,
					onPaginationChanged: ce,
					paginationPageSize: x,
					onFilterChanged: le,
					onSortChanged: fe,
					onGridReady: se,
					onRowClicked: pe,
					onSelectionChanged: me,
					selection: Y,
					className: G("ag-theme-quartz", V, U, "flx-table"),
					paginationPageSizeSelector: v
				})
			}),
			C && /* @__PURE__ */ Q("div", {
				className: "background-loader",
				children: /* @__PURE__ */ Q(he, {
					backgroundColor: "#ffffff",
					borderColor: "transparent",
					visualType: "custom",
					size: "custom",
					radius: 90
				})
			})
		]
	}), F?.task && /* @__PURE__ */ Q(de, {
		onOpenChange: (e) => {
			e || (P(-1), b(e));
		},
		open: y,
		dismissible: !0,
		className: G(re, "flx-task-details-modal"),
		container: E,
		children: /* @__PURE__ */ Q(Ct, {
			task: F.task,
			details: F.details,
			searchAssignees: F.searchAssignees,
			onActionUpdate: F.onActionUpdate,
			onPriorityUpdate: F.onPriorityUpdate,
			onViewApplication: F.onViewApplication,
			onCommentDelete: F.onCommentDelete,
			onCommentCreate: F.onCommentCreate
		})
	})] });
}, At = ({ style: e, className: t, templateConfig: n, authToken: o, anonymousSessionId: s, language: l, themeId: u, apiUrl: d, locale: f, staticAssetsPath: p, appInfo: m, buildId: h, workspaceId: g, legacyHttpVersion: _, fw: v, viewId: y, cache: b, stages: S }) => {
	let [C, w] = c(), [T, E] = c({}), [D, O] = c(!1), k = a(() => ({
		authToken: o,
		anonymousSessionId: s,
		language: l,
		themeId: u,
		apiUrl: d,
		locale: f,
		staticAssetsPath: p,
		appInfo: m,
		buildId: h,
		workspaceId: g,
		legacyHttpVersion: _,
		fw: v,
		viewId: y,
		cache: b,
		stages: S
	}), [
		o,
		s,
		l,
		u,
		d,
		f,
		p,
		m,
		h,
		g,
		_,
		v,
		y,
		b,
		S
	]);
	return r(() => {
		ee(k).then(({ view: e, enumerations: t }) => {
			w(e), E(t), O(!0);
		});
	}, [k]), i(() => {
		o && x() && V(o);
	}, [o]), r(() => () => z(), []), !D || !C ? /* @__PURE__ */ Q(de, {
		defaultOpen: !0,
		style: {
			backgroundColor: "transparent",
			boxShadow: "none"
		},
		children: /* @__PURE__ */ Q(he, {
			backgroundColor: "#ffffff",
			borderColor: "transparent",
			visualType: "custom",
			size: "custom",
			radius: 90
		})
	}) : /* @__PURE__ */ Q(kt, {
		view: C,
		enumerations: T,
		language: l,
		style: e,
		className: t,
		templateConfig: n
	});
};
//#endregion
export { Dt as n, At as t };
